import { useAtom } from '@reatom/npm-react'
import { match } from 'ts-pattern'

import { profileAtom } from '@root/entities/profile'
import { ProfilePremiumList } from '@root/features/premium/profile-premium-list'
import { ProfileOwner } from '@root/features/user/profile/model/profile-owner'

import { ProfilePositionsView } from './profile-positions-view'
import { ProfileReferral } from './profile-referral'
import { ProfileStatistics } from './profile-statistics'
import { ProfileTransactions } from './profile-transactions'

import type { ProfileTab } from '@root/features/user/profile-header/atoms'

type ProfileScreenCurrentProps = {
  tab: ProfileTab
}

export const ProfileScreenCurrent: React.FC<ProfileScreenCurrentProps> = ({
  tab,
}) => {
  // My profile
  const [profile] = useAtom(profileAtom)

  return match(tab)
    .with('referral', () => <ProfileReferral />)
    .with('transactions', () => (
      <ProfileTransactions profileOwner={ProfileOwner.CurrentUser} />
    ))
    .with('stats', () =>
      profile ? (
        <ProfileStatistics
          delugeId={profile.delugeId}
          wallets={profile.wallets}
          profileOwner={ProfileOwner.CurrentUser}
        />
      ) : undefined,
    )
    .with('premium', () => <ProfilePremiumList />)
    .with('positions-active', () =>
      profile?.delugeId ? (
        <ProfilePositionsView delugeId={profile.delugeId} />
      ) : undefined,
    )
    .exhaustive()
}
